/* 13.10.2026 (власник): рушій коротких відеоінструкцій (блоки .fla): телефон з кабінетом Starlink, палець показує,
   куди натиснути, праворуч список кроків. Один рушій на всі ролики: кожен ролик це розмітка екранів і розклад
   у <script type="application/json" data-fla-cfg> усередині блока. Рух рахується від часу (render(t)), тому є
   пауза й перемотка, а той самий код дає кадри для відеофайла (root.flaRender(ms)). Вигляд: adaptis-flow-anim.css.

   Розклад (усі часи в мс):
     T       тривалість кола
     steps   [[початок, заголовок, підказка], ...]: рядки списку праворуч і підпис над кадром
     fin     коли всі рядки списку стають виконаними
     end     [початок, «Готово», заголовок, підказка]: підсумковий екран і підпис
     scr     {екран: [поява від, до, зникнення від, до]}: null у появі означає «видно з початку»
     fx      [["type", елемент, від, до]            текст набирається
              ["show", елемент, від, до, зник від, зник до]
              ["rise", елемент, від, до, зсув]
              ["scroll", елемент, від, до, "max" або назва елемента, до якого гортаємо]
              ["hot", ціль, від, до]]               синє кільце без натискання
     taps    [[ціль, рух від, рух до, натиск, зникнення, dx, dy], ...]: dx, dy це звідки з'являється палець
     swipes  [[екран, від, до, зникнення], ...]: палець гортає сторінку
     still   мить для нерухомого кадру, коли в системі вимкнено анімації */
(function(){
  function clamp(x){ return x < 0 ? 0 : x > 1 ? 1 : x; }
  function pr(x, a, b){ return clamp((x - a) / (b - a)); }
  function ease(x){ return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function init(root){
    if (root.dataset.on) return;
    var cfgEl = root.querySelector('[data-fla-cfg]');
    if (!cfgEl) return;
    var C;
    try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.dataset.on = '1';
    var stage = root.querySelector('[data-fla-stage]'), inner = root.querySelector('[data-fla-in]');
    var capN = root.querySelector('[data-fla-n]'), capT = root.querySelector('[data-fla-t]'), capS = root.querySelector('[data-fla-s]');
    var fill = root.querySelector('[data-fla-fill]'), bar = root.querySelector('[data-fla-bar]'), pp = root.querySelector('[data-fla-pp]');
    var fing = root.querySelector('[data-fla-fing]'), rip = root.querySelector('[data-fla-rip]'), done = root.querySelector('[data-fla-done]');
    var lis = [].slice.call(root.querySelectorAll('.fla__li'));
    var scr = {}, hot = {}, els = {};
    [].forEach.call(root.querySelectorAll('[data-scr]'), function(x){ scr[x.getAttribute('data-scr')] = x; });
    [].forEach.call(root.querySelectorAll('[data-fla-hot]'), function(x){ hot[x.getAttribute('data-fla-hot')] = x; });
    [].forEach.call(root.querySelectorAll('[data-fla-el]'), function(x){ var k = x.getAttribute('data-fla-el'); (els[k] = els[k] || []).push(x); });
    var BW = 480, T = C.T, S = C.steps, END = C.end[0], FIN = C.fin, FADE = T - 350;
    var order = Object.keys(C.scr);
    /* 17.10.2026 (s75): екран, який іде, лишається цілим, поки поверх нього проявляється новий: раніше обидва були
       напівпрозорі одночасно і кадр двоївся. Новий екран лежить вище за старий (z-index за часом появи). */
    var cover = {}, over = {};
    order.forEach(function(k){
      var s = C.scr[k];
      if (s[2] == null) return;
      order.forEach(function(j){
        var q = C.scr[j];
        if (j !== k && q[0] != null && Math.abs(q[0] - s[2]) < 60 && q[0] >= (s[0] == null ? -1 : s[0])) { cover[k] = true; over[j] = true; }
      });
    });
    /* новий екран над старим проявляється за 180 мс: довше видно обидва разом */
    order.slice().sort(function(a, b){ return (C.scr[a][0] == null ? -1 : C.scr[a][0]) - (C.scr[b][0] == null ? -1 : C.scr[b][0]); })
      .forEach(function(k, z){ scr[k].style.zIndex = z + 1; });
    var cap = capT.parentNode, box = [];
    var scale = 1, ready = false, t = 0, last = 0, raf = 0, paused = false, seen = false, capKey = -2, amount = [];
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function each(k, fn){ (els[k] || []).forEach(fn); }
    function fit(){
      var w = stage.clientWidth;
      if (!w) return false;
      scale = w / BW;
      inner.style.transform = 'scale(' + scale + ')';
      /* на скільки гортати: до кінця сторінки або доки названий елемент не стане під шапкою екрана */
      C.fx.forEach(function(f, i){
        if (f[0] !== 'scroll') return;
        var el = (els[f[1]] || [])[0];
        if (!el) return;
        var max = Math.max(0, el.scrollHeight - (el.parentNode.clientHeight - el.offsetTop));
        var to = f[4] === 'max' ? null : (els[f[4]] || [])[0];
        amount[i] = to ? Math.min(max, Math.max(0, to.offsetTop - el.offsetTop - 10)) : max;
      });
      /* 17.10 (s75): підпис над кадром завжди висотою з найдовший крок, щоб кадр не смикався, коли рядків стає більше */
      cap.style.minHeight = '';
      var hi = 0, keep = [capN.textContent, capT.textContent, capS.textContent];
      S.concat([[0, C.end[2], C.end[3]]]).forEach(function(r){ capT.textContent = r[1]; capS.textContent = r[2]; hi = Math.max(hi, cap.offsetHeight); });
      capN.textContent = keep[0]; capT.textContent = keep[1]; capS.textContent = keep[2];
      if (hi) cap.style.minHeight = hi + 'px';
      box = [];
      ready = true;
      return true;
    }
    function mid(el){
      var r0 = inner.getBoundingClientRect(), r = el.getBoundingClientRect();
      return {x:(r.left + r.width / 2 - r0.left) / scale, y:(r.top + r.height / 2 - r0.top) / scale, w:r.width / scale, h:r.height / scale};
    }
    function frame(el){
      var ph = el.closest('.fla__phone,.fla__x');
      if (!ph) return null;
      for (var i = 0; i < box.length; i++) if (box[i].el === ph) return box[i];
      var m = mid(ph), r = {el:ph, l:m.x - m.w / 2 + 13, r:m.x + m.w / 2 - 13, t:m.y - m.h / 2 + 13, b:m.y + m.h / 2 - 13};
      box.push(r);
      return r;
    }
    function show(el, o, dy){ el.style.opacity = o; el.style.transform = dy ? 'translateY(' + ((1 - o) * dy).toFixed(2) + 'px)' : ''; }
    function render(tt){
      if (!ready && !fit()) return;
      var loop = tt >= T - 400;                       /* останні миті кола: під підсумком уже стоїть перший екран */
      var u = loop ? 0 : tt;
      /* екрани телефона */
      order.forEach(function(k, j){
        var s = C.scr[k], o = (s[0] == null ? 1 : pr(u, s[0], over[k] ? s[0] + 180 : s[1])) * (s[2] == null ? 1 : cover[k] ? (u < s[3] ? 1 : 0) : 1 - pr(u, s[2], s[3]));
        show(scr[k], o, 0);       /* без зсуву: шапка STARLINK однакова на всіх екранах і не двоїться */
      });
      /* ефекти */
      for (var k in hot) hot[k].style.setProperty('--hot', 0);
      var scrolls = {};
      C.fx.forEach(function(f, i){
        var p = pr(u, f[2], f[3]);
        if (f[0] === 'type') each(f[1], function(el){ el.style.clipPath = 'inset(0 ' + ((1 - p) * 100).toFixed(1) + '% 0 0)'; });
        else if (f[0] === 'show') each(f[1], function(el){ el.style.opacity = p * (f[4] == null ? 1 : 1 - pr(u, f[4], f[5])); });
        else if (f[0] === 'rise') each(f[1], function(el){ el.style.transform = 'translateY(' + ((1 - p) * (f[4] || 10)).toFixed(2) + 'px)'; });
        else if (f[0] === 'scroll'){ var q = scrolls[f[1]] || {v:0, prev:0}; q.v += ((amount[i] || 0) - q.prev) * ease(p); q.prev = amount[i] || 0; scrolls[f[1]] = q; }
        else if (f[0] === 'hot' && hot[f[1]]) hot[f[1]].style.setProperty('--hot', pr(u, f[2], f[2] + 300) * (1 - pr(u, f[3], f[3] + 300)));
      });
      for (var sk in scrolls) each(sk, function(el){ el.style.transform = 'translateY(' + (-scrolls[sk].v).toFixed(2) + 'px)'; });
      /* палець */
      var fo = 0, fx = 0, fy = 0, fs = 1, ro = 0, rs = 1;
      C.taps.forEach(function(v){
        var a = v[1], b = v[2], tap = v[3], out = v[4];
        if (u < a || u > out || !hot[v[0]]) return;
        /* палець стає на нижній правий край цілі, щоб не закривати напис на ній */
        var p = mid(hot[v[0]]), e = ease(pr(u, a, b));
        var tx = p.x + Math.min(p.w * 0.4, 44), ty = p.y + Math.min(p.h * 0.5, 10);
        fx = tx + v[5] * (1 - e); fy = ty + v[6] * (1 - e);
        /* 17.10 (s75): палець з'являється всередині телефона (сцени), а не з-за його краю */
        var fr = frame(hot[v[0]]);
        if (fr){ fx = Math.max(fr.l, Math.min(fr.r, fx)); fy = Math.max(fr.t, Math.min(fr.b, fy)); }
        fo = pr(u, a, a + 220) * (1 - pr(u, out - 260, out));
        hot[v[0]].style.setProperty('--hot', pr(u, a + 250, a + 500) * (1 - pr(u, tap + 150, tap + 350)));
        if (u >= tap){ var q = pr(u, tap, tap + 380); fs = 1 - 0.24 * Math.sin(Math.PI * q); ro = q < 1 ? 1 - q : 0; rs = 0.6 + 2.2 * q; }
      });
      (C.swipes || []).forEach(function(w){
        if (u < w[1] - 350 || u > w[3] || !scr[w[0]]) return;
        var m = mid(scr[w[0]]), g = ease(pr(u, w[1], w[2]));
        fx = m.x + 14; fy = m.y + 70 - 120 * g;
        fo = pr(u, w[1] - 350, w[1] - 100) * (1 - pr(u, w[2], w[3]));
      });
      fing.style.opacity = fo;
      fing.style.transform = 'translate(' + fx.toFixed(2) + 'px,' + fy.toFixed(2) + 'px) scale(' + fs.toFixed(3) + ')';
      rip.style.opacity = ro;
      rip.style.transform = 'translate(' + fx.toFixed(2) + 'px,' + fy.toFixed(2) + 'px) scale(' + rs.toFixed(3) + ')';
      /* список кроків і підпис */
      var st = 0;
      for (var i = 0; i < S.length; i++) if (u >= S[i][0]) st = i;
      var fin = !loop && tt >= FIN;
      lis.forEach(function(li, j){
        var on = !fin && j === st;
        li.classList.toggle('is-on', on);
        li.classList.toggle('is-done', fin || j < st);
        li.firstElementChild.style.opacity = on ? pr(u, S[j][0], S[j][0] + 250) : 0;
      });
      show(done, loop ? 1 - pr(tt, FADE, T) : pr(tt, END, END + 400), 10);
      var key = !loop && tt >= END ? 99 : st;
      if (capKey !== key){
        capKey = key;
        capN.textContent = key === 99 ? C.end[1] : 'Крок ' + (st + 1) + ' з ' + S.length;
        capT.textContent = key === 99 ? C.end[2] : S[st][1];
        capS.textContent = key === 99 ? C.end[3] : S[st][2];
      }
      fill.style.width = (tt / T * 100).toFixed(2) + '%';
    }
    function tick(now){
      raf = 0;
      if (paused || !seen) { last = 0; return; }
      if (last) t = (t + (now - last)) % T;
      last = now;
      render(t);
      raf = requestAnimationFrame(tick);
    }
    function go(){ if (!raf && !paused && seen && !still) { last = 0; raf = requestAnimationFrame(tick); } }
    function refit(){ ready = false; if (fit()) render(t); }
    pp.addEventListener('click', function(){
      paused = !paused;
      root.classList.toggle('is-paused', paused);
      pp.setAttribute('aria-label', paused ? 'Продовжити' : 'Пауза');
      go();
    });
    bar.addEventListener('click', function(e){
      var r = bar.getBoundingClientRect();
      t = clamp((e.clientX - r.left) / r.width) * T;
      render(t);
    });
    window.addEventListener('resize', refit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
    if ('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ seen = es[0].isIntersecting; if (seen) { refit(); go(); } }, {threshold:0.3}).observe(stage);
    } else { seen = true; }
    /* блок щойно показали (перемикач «Відео / Покроково»): починаємо спочатку */
    root.addEventListener('fla:open', function(){ t = 0; capKey = -2; refit(); go(); });
    if (still){ t = C.still || 0; pp.hidden = true; }
    /* для перевірки й для відеофайла: кадр за часом */
    root.flaRender = function(ms){ paused = true; if (!ready) fit(); t = ms; render(ms); return T; };
    refit();
    go();
  }
  /* Перемикач «Відео / Покроково»: стан це клас is-steps на перемикачі, показ і приховування робить CSS
     (adaptis-flow-anim.css). Відео показано першим; повернення до відео починає ролик спочатку. */
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('[data-fla-sw] button') : null;
    if (!b) return;
    var sw = b.parentNode, video = b.getAttribute('data-fla-v') === 'video', pane = sw.nextElementSibling;
    [].forEach.call(sw.querySelectorAll('button'), function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    sw.classList.toggle('is-steps', !video);
    var fla = pane && pane.querySelector('[data-fla]'), npa = pane && pane.querySelector('[data-npa]');
    if (video && fla){ init(fla); fla.dispatchEvent(new Event('fla:open')); }
    if (video && npa) npa.dispatchEvent(new Event('npa:open'));
  });
  function all(){ [].forEach.call(document.querySelectorAll('[data-fla]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.adaptisFla = all;
})();
